import { createFileRoute } from "@tanstack/react-router";
import { VideoProductionServicePage } from "./services_.video-production";

export const Route = createFileRoute("/services_/branding-creatives-and-video-production-services")({
  head: () => ({
    meta: [
      {
        title: "Video Production Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "High-Quality End-to-End Video Production.",
      },
    ],
  }),
  component: VideoProductionServicePage,
});
